import { menuItemClasses } from "@mui/material/MenuItem";
import type {
  Components,
  PaletteColor,
  PaletteColorChannel,
  Theme,
} from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

import type { ColorName } from "../../options/palette";

export const MuiMenuItem: Components<Theme>["MuiMenuItem"] = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        background: theme.palette.common.white,
        fontSize: theme.typography.fontSizeMd,

        variants: Object.entries(theme.palette)
          .filter((args): args is [ColorName, PaletteColor] => {
            const [, values] = args;
            return typeof values === "object" && "main" in values;
          })
          .map(([color, values]) => {
            const cssColors = theme.vars?.palette[color] as
              PaletteColorChannel | undefined;

            return {
              props: {
                color,
              },
              style: {
                [`&.${menuItemClasses.selected}`]: {
                  backgroundColor: cssColors
                    ? `rgba(${cssColors.mainChannel} / ${theme.vars!.palette.action.selectedOpacity})`
                    : alpha(values.main, theme.palette.action.selectedOpacity),
                  [`&.${menuItemClasses.focusVisible}`]: {
                    backgroundColor: cssColors
                      ? `rgba(${cssColors.mainChannel} / calc(${theme.vars!.palette.action.selectedOpacity} + ${theme.vars!.palette.action.focusOpacity}))`
                      : alpha(
                          values.main,
                          theme.palette.action.selectedOpacity +
                            theme.palette.action.focusOpacity,
                        ),
                  },
                },
                [`&.${menuItemClasses.selected}:hover`]: {
                  backgroundColor: cssColors
                    ? `rgba(${cssColors.mainChannel} / calc(${theme.vars!.palette.action.selectedOpacity} + ${theme.vars!.palette.action.hoverOpacity}))`
                    : alpha(
                        values.main,
                        theme.palette.action.selectedOpacity +
                          theme.palette.action.hoverOpacity,
                      ),
                  // Reset on touch devices, it doesn't add specificity
                  "@media (hover: none)": {
                    backgroundColor: cssColors
                      ? `rgba(${cssColors.mainChannel} / ${theme.vars!.palette.action.selectedOpacity})`
                      : alpha(
                          values.main,
                          theme.palette.action.selectedOpacity,
                        ),
                  },
                },
              },
            };
          }),
      };
    },
  },
};
